// extracted by mini-css-extract-plugin
export var dividerLine = "_46-0";
export var errorBackground = "_46-1";